export const PRIORITY = [{
  name: 'HighPriority',
  label: 'High',
  value: '1'
}, {
  name: 'MediumPriority',
  label: 'Medium',
  value: '2'
}, {
  name: 'Low/MaintenancePriority',
  label: 'Low / Maintenance',
  value: '3'
}, {
  name: 'RecommendationPriority',
  label: 'Recommendation',
  value: '4'
}]
export const ASSESSMENT = [{
  name: 'MaintenanceRequiredAssess',
  label: 'Maintenance Required',
  value: '1'
}, {
  name: 'RiskofInjuryAssess',
  label: 'Risk of Injury',
  value: '2'
}, {
  name: 'RiskofSeriousInjuryAssess',
  label: 'Risk of Serious Injury',
  value: '3'
}, {
  name: 'RiskofDeathAssess',
  label: 'Risk of Death',
  value: '4'
}]
export const COST_ESTIMATE = [{
  name: '0-500',
  label: '$0 to $500',
  value: '1'
}, {
  name: '501-1000',
  label: '$501 to $1000',
  value: '2'
}, {
  name: '1001-1500',
  label: '$1001 to $1500',
  value: '3'
}, {
  name: '1501-2000',
  label: '$1501 to $2000',
  value: '4'
}, {
  name: '2001',
  label: '> $2001',
  value: '5'
}]



// WEBPACK FOOTER //
// ./src/OHSHazards.js